'use client';

import { Root, Thumb } from '@radix-ui/react-switch';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export function Switch({
  className,
  ...props
}: ComponentProps<typeof Root>): JSX.Element {
  return (
    <Root
      data-slot='switch'
      className={cn(
        'peer inline-flex h-4.5 w-7.5 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'data-[state=checked]:bg-illicitGreen-500 data-[state=unchecked]:bg-[#f2f3f5] dark:data-[state=unchecked]:bg-input/80',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <Thumb
        data-slot='switch-thumb'
        className={cn(
          'bg-background pointer-events-none block rounded-full ring-0 transition-transform',
          'data-[state=checked]:translate-x-[calc(100%-4px)] data-[state=unchecked]:translate-x-0 dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground',
          'size-[15.88px] shadow-[0px_3px_7px_0px_theme(colors.black/0.12)]',
        )}
      />
    </Root>
  );
}
